import React from "react";
import { Image, View } from "react-native";
import Text from "../../components/Text";

const SafeModeSection = ({ header, image, children, styles }) => {
	return (
		<View>
			<View style={{ marginTop: 50 }}>
				<Text
					type="default"
					style={{
						fontWeight: "600",
						marginLeft: 20,
						marginBottom: 15,
						fontSize: 15,
					}}>
					{header}
				</Text>
				<Image source={image} style={styles} />
				<View
					style={{
						marginHorizontal: 25,
						marginTop: 25,
					}}>
					{children}
				</View>
			</View>
		</View>
	);
};

export default SafeModeSection;
